webpackJsonp([1],{

/***/ 166:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/utils/fetch.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);


/* harmony default export */ var fetch_defaultExport = (function (url, options) {
  options = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default.a({}, options, { credentials: 'include' });
  return fetch(url, options).then(function (response) {
    var contentType = response.headers.get('content-type');
    if (contentType && contentType.indexOf('application/json') !== -1) {
      return response.json().then(function (data) {
        if (data.status !== 0) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new Error(data.message));
        }
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(data);
      });
    } else {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new Error('the response is not JSON'));
    }
  });
});
// CONCATENATED MODULE: ./src/utils/axios.js
/* harmony import */ var axios___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(152);
/* harmony import */ var axios___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(axios___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var axios___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(101);
/* harmony import */ var axios___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(axios___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);




/* harmony default export */ var axios_defaultExport = (function (options) {
  var DefaultParams = {
    url: '',
    method: 'get',
    credentials: 'include'
  };
  options = axios___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default.a({}, DefaultParams, options);
  try {
    return __WEBPACK_IMPORTED_MODULE_2_axios___default.a(options).then(function (response) {
      var headers = response.headers,
          data = response.data;

      var contentType = headers['content-type'];
      if (contentType && contentType.indexOf('application/json') !== -1) {
        var status = data.status,
            message = data.message;

        if (status !== 0) {
          return axios___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new Error(message));
        }
        return axios___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(data);
      } else {
        return axios___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new Error('the response is not JSON'));
      }
    });
  } catch (e) {
    console.error('axios error: ', e);
  }
});
// CONCATENATED MODULE: ./src/utils/index.js



// CONCATENATED MODULE: ./src/server/index.js


function getSceneInfo(id) {
  return axios_defaultExport({
    url: '/api/getSceneInfo',
    params: {
      sceneId: id
    }
  });
}


// CONCATENATED MODULE: ./src/const/actions.js
var INCREMENT = 'INCREMENT';
var DECREMENT = 'DECREMENT';
var INCREMENT_IF_ODD = 'INCREMENT_IF_ODD';
var INCREMENT_ASYNC = 'INCREMENT_ASYNC';
var INCREMENT_ASYNC_ONCE = 'INCREMENT_ASYNC_ONCE';

// CONCATENATED MODULE: ./src/const/countTimer.js
var CT_SHOW = 'CT_SHOW';
var CT_SHOW_REQUEST = 'CT_SHOW_REQUEST';

var CT_HIDE = 'CT_HIDE';
var CT_HIDE_REQUEST = 'CT_HIDE_REQUEST';


// CONCATENATED MODULE: ./src/saga/index.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__ = __webpack_require__(151);


var _marked = [incrementAsync, watchIncrementAsyncSaga, watchIncrementAsyncOnceSaga, helloSaga, setCountTimerShowRequest, setCountTimerShowRequestSaga, rootSaga].map(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark);







function incrementAsync() {
  var _Promise;

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function incrementAsync$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga__["b" /* delay */](1000);

        case 2:
          _context.next = 4;
          return __WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["b" /* put */]({ type: INCREMENT });

        case 4:
          _context.prev = 4;
          _context.next = 7;
          return getSceneInfo(123);

        case 7:
          _Promise = _context.sent;

          console.log(_Promise);
          _context.next = 14;
          break;

        case 11:
          _context.prev = 11;
          _context.t0 = _context['catch'](4);

          console.log(_context.t0);

        case 14:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this, [[4, 11]]);
}

function watchIncrementAsyncSaga() {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchIncrementAsyncSaga$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return __WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["c" /* takeEvery */](INCREMENT_ASYNC, incrementAsync);

        case 2:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked[1], this);
}

function watchIncrementAsyncOnceSaga() {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchIncrementAsyncOnceSaga$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return __WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["d" /* takeLatest */](INCREMENT_ASYNC_ONCE, incrementAsync);

        case 2:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked[2], this);
}

function helloSaga() {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function helloSaga$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked[3], this);
}

function setCountTimerShowRequest() {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function setCountTimerShowRequest$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return __WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["b" /* put */]({
            type: CT_SHOW
          });

        case 2:
          _context5.next = 4;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga__["b" /* delay */](5000);

        case 4:
          _context5.next = 6;
          return __WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["b" /* put */]({
            type: CT_HIDE
          });

        case 6:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked[4], this);
}

function setCountTimerShowRequestSaga() {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function setCountTimerShowRequestSaga$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return __WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["d" /* takeLatest */](CT_SHOW_REQUEST, setCountTimerShowRequest);

        case 2:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked[5], this);
}

function rootSaga() {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function rootSaga$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return __WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["a" /* all */]([helloSaga(), watchIncrementAsyncSaga(), watchIncrementAsyncOnceSaga(), setCountTimerShowRequestSaga()]);

        case 2:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked[6], this);
}
// CONCATENATED MODULE: ./src/reducers/counter.js


function counter() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var action = arguments[1];

  switch (action.type) {
    case INCREMENT:
      return state + 1;
    case INCREMENT_IF_ODD:
      return state % 2 !== 0 ? state + 1 : state;
    case DECREMENT:
      return state - 1;
    default:
      return state;
  }
}
// CONCATENATED MODULE: ./src/reducers/countTimer.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

var STATE = {
  show: false
};
function countTimer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : STATE;
  var action = arguments[1];

  switch (action.type) {
    case 'CT_SHOW':
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default.a({}, state, { show: true });
    case 'CT_HIDE':
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default.a({}, state, { show: false });
    default:
      return state;
  }
}
// CONCATENATED MODULE: ./src/reducers/index.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(98);




/* harmony default export */ var reducers_defaultExport = (__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */]({
  counter: counter,
  countTimer: countTimer
}));
// CONCATENATED MODULE: ./src/components/App/index.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_dom__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames_bind__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames_bind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames_bind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__index_styl__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__index_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__index_styl__);










var cx = __WEBPACK_IMPORTED_MODULE_8_classnames_bind___default.a.bind(__WEBPACK_IMPORTED_MODULE_9__index_styl___default.a);

var App = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default.a(App, _Component);

  function App() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default.a(this, App);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default.a(this, (App.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default.a(App)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default.a(App, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a('div', {
        className: cx('app-p-box')
      }, void 0, this.props.children);
    }
  }]);

  return App;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

/* harmony default export */ var App_defaultExport = (App);
// CONCATENATED MODULE: ./src/containers/AppContainer/index.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_dom__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(51);










var AppContainer_AppContainer = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a(AppContainer, _Component);

  function AppContainer() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a(this, AppContainer);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a(this, (AppContainer.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a(AppContainer)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a(AppContainer, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(App_defaultExport, this.props);
    }
  }]);

  return AppContainer;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

/* harmony default export */ var AppContainer_defaultExport = (__WEBPACK_IMPORTED_MODULE_6_react_router_dom__["e" /* withRouter */](__WEBPACK_IMPORTED_MODULE_7_react_redux__["b" /* connect */]()(AppContainer_AppContainer)));
// CONCATENATED MODULE: ./src/components/Brand/index.js
/* harmony import */ var Brand___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__ = __webpack_require__(9);
/* harmony import */ var Brand___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default = __webpack_require__.n(Brand___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);



var _ref = Brand___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a("title", {});

var _ref2 = Brand___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a("g", {}, void 0, Brand___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a("path", {
	d: "M53.29 80.035l7.32.002 2.41 8.24 13.128-8.24h15.477v-67.98H53.29v67.978zm7.79-60.598h22.756v53.22h-8.73l-8.718 5.473-1.587-5.46-3.72-.012v-53.22zM46.818 43.162h-16.35c.545-8.467.687-16.12.687-22.955h15.987s.615-7.05-2.68-6.97H16.807c1.09-4.1 2.46-8.332 4.1-12.708 0 0-7.523 0-10.085 6.74-1.06 2.78-4.128 13.48-9.592 24.41 1.84-.2 7.927-.37 11.512-6.94.66-1.84.785-2.08 1.605-4.54h9.02c0 3.28-.374 20.9-.526 22.95H6.51c-3.67 0-4.863 7.38-4.863 7.38H22.14C20.765 66.11 13.385 79.24 0 89.62c6.403 1.828 12.784-.29 15.937-3.094 0 0 7.182-6.53 11.12-21.64L43.92 85.18s2.473-8.402-.388-12.496c-2.37-2.788-8.768-10.33-11.496-13.064l-4.57 3.627c1.363-4.368 2.183-8.61 2.46-12.71H49.19s-.027-7.38-2.372-7.38zm128.752-.502c6.51-8.013 14.054-18.302 14.054-18.302s-5.827-4.625-8.556-1.27c-1.874 2.548-11.51 15.063-11.51 15.063l6.012 4.51zm-46.903-18.462c-2.814-2.577-8.096.667-8.096.667s12.35 17.2 12.85 17.953l6.08-4.29s-8.02-11.752-10.83-14.33zM199.99 46.5c-6.18 0-40.908.292-40.953.292v-31.56c1.503 0 3.882-.124 7.14-.376 12.773-.753 21.914-1.25 27.427-1.504 0 0 3.817-8.496-.185-10.45-.96-.37-7.24 1.43-7.24 1.43s-51.63 5.153-72.61 5.64c.5 2.756 2.38 5.336 4.93 6.11 4.16 1.087 7.09.53 15.36.277 7.76-.5 13.65-.76 17.66-.76v31.19h-41.71s.88 6.97 7.97 7.14h33.73v22.16c0 4.364-3.498 6.87-7.65 6.6-4.4.034-8.15-.36-13.027-.566.623 1.24 1.977 4.496 6.035 6.824 3.087 1.502 5.054 2.053 8.13 2.053 9.237 0 14.27-5.4 14.027-14.16V53.93h38.235c3.026 0 2.72-7.432 2.72-7.432z",
	"fill-rule": "evenodd"
}));

function Brand(props) {
	return Brand___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a("span", {}, void 0, Brand___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a("svg", {
		viewBox: "0 0 200 91",
		width: "64",
		height: "30",
		"aria-hidden": "true",
		style: { "fill": "rgb(15, 136, 235)", "height": "30px", "width": "64px" }
	}, void 0, _ref, _ref2));
}

/* harmony default export */ var Brand_defaultExport = (Brand);
// CONCATENATED MODULE: ./src/components/Links/index.js
/* harmony import */ var Links___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__ = __webpack_require__(9);
/* harmony import */ var Links___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default = __webpack_require__.n(Links___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__);
/* harmony import */ var Links___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(16);
/* harmony import */ var Links___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(Links___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var Links___WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var Links___WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(Links___WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var Links___WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(18);
/* harmony import */ var Links___WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(Links___WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var Links___WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(19);
/* harmony import */ var Links___WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(Links___WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var Links___WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(20);
/* harmony import */ var Links___WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(Links___WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var Links___WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(3);
/* harmony import */ var Links___WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(Links___WEBPACK_IMPORTED_MODULE_6_react__);








var LinkChild = function (_React$Component) {
	Links___WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default.a(LinkChild, _React$Component);

	function LinkChild(props) {
		Links___WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default.a(this, LinkChild);

		var _this = Links___WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default.a(this, (LinkChild.__proto__ || Links___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default.a(LinkChild)).call(this, props));

		_this.state = {};
		_this.handleClick = _this.handleClick.bind(_this);
		return _this;
	}

	Links___WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default.a(LinkChild, [{
		key: 'handleClick',
		value: function handleClick() {
			window.location.href = this.props.links;
		}
	}, {
		key: 'render',
		value: function render() {
			return Links___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a('span', {
				onClick: this.handleClick,
				className: 'AppHeader-navItem is-active'
			}, void 0, this.props.name);
		}
	}]);

	return LinkChild;
}(Links___WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

function Links(props) {
	var arr = [{ name: '首页', links: 'https://www.zhihu.com/' }, { name: '发现', links: 'https://www.zhihu.com/explore' }, { name: '话题', links: 'https://www.zhihu.com/topic' }];
	var CompArr = arr.map(function (item, index) {
		return Links___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a(LinkChild, {
			name: item.name,
			links: item.links
		}, index);
	});

	return Links___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a('nav', {
		className: 'AppHeader-nav'
	}, void 0, CompArr);
}

/* harmony default export */ var Links_defaultExport = (Links);
// CONCATENATED MODULE: ./src/components/SearchBar/index.js
/* harmony import */ var SearchBar___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__ = __webpack_require__(9);
/* harmony import */ var SearchBar___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default = __webpack_require__.n(SearchBar___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__);
/* harmony import */ var SearchBar___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(16);
/* harmony import */ var SearchBar___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(SearchBar___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var SearchBar___WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var SearchBar___WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(SearchBar___WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var SearchBar___WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(18);
/* harmony import */ var SearchBar___WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(SearchBar___WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var SearchBar___WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(19);
/* harmony import */ var SearchBar___WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(SearchBar___WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var SearchBar___WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(20);
/* harmony import */ var SearchBar___WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(SearchBar___WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var SearchBar___WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(3);
/* harmony import */ var SearchBar___WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(SearchBar___WEBPACK_IMPORTED_MODULE_6_react__);








var SearchBar__ref = SearchBar___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a("title", {});

var SearchBar__ref2 = SearchBar___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a("g", {}, void 0, SearchBar___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a("path", {
	d: "M12.054 10.864c.887-1.14 1.42-2.57 1.42-4.127C13.474 3.017 10.457 0 6.737 0S0 3.016 0 6.737c0 3.72 3.016 6.737 6.737 6.737 1.556 0 2.985-.533 4.127-1.42l3.103 3.104c.765.46 1.705-.37 1.19-1.19l-3.103-3.104zm-5.317.925c-2.786 0-5.053-2.267-5.053-5.053S3.95 1.684 6.737 1.684 11.79 3.95 11.79 6.737 9.522 11.79 6.736 11.79z"
}));

var _ref3 = SearchBar___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a("button", {
	className: "Button QuestionAskButton SearchBar-askButton Button--primary Button--blue",
	type: "button"
}, void 0, "\u63D0\u95EE");

var SearchBar = function (_React$Component) {
	SearchBar___WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default.a(SearchBar, _React$Component);

	function SearchBar(props) {
		SearchBar___WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default.a(this, SearchBar);

		return SearchBar___WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default.a(this, (SearchBar.__proto__ || SearchBar___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default.a(SearchBar)).call(this, props));
	}

	SearchBar___WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default.a(SearchBar, [{
		key: "render",
		value: function render() {
			var _this2 = this;

			return SearchBar___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a("div", {
				className: "SearchBar"
			}, void 0, SearchBar___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a("div", {
				className: "Input-wrapper"
			}, void 0, SearchBar___WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("input", { type: "text", maxLength: "100", className: "Input", placeholder: "\u641C\u7D22\u4F60\u611F\u5174\u8DA3\u7684\u5185\u5BB9\u2026", ref: function ref(input) {
					_this2.textInput = input;
				} }), SearchBar___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a("div", {
				className: "Input-after"
			}, void 0, SearchBar___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a("button", {
				className: "Button SearchBar-searchIcon Button--primary",
				"aria-label": "\u641C\u7D22",
				type: "button"
			}, void 0, SearchBar___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a("svg", {
				viewBox: "0 0 16 16",
				className: "Icon Icon--search",
				width: "16",
				height: "16",
				"aria-hidden": "true",
				style: { "height": "16px", "width": "16px" }
			}, void 0, SearchBar__ref, SearchBar__ref2)))), _ref3);
		}
	}]);

	return SearchBar;
}(SearchBar___WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

/* harmony default export */ var SearchBar_defaultExport = (SearchBar);
// CONCATENATED MODULE: ./src/components/UserInfo/index.js
/* harmony import */ var UserInfo___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__ = __webpack_require__(9);
/* harmony import */ var UserInfo___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default = __webpack_require__.n(UserInfo___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__);
/* harmony import */ var UserInfo___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(16);
/* harmony import */ var UserInfo___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(UserInfo___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var UserInfo___WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var UserInfo___WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(UserInfo___WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var UserInfo___WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(18);
/* harmony import */ var UserInfo___WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(UserInfo___WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var UserInfo___WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(19);
/* harmony import */ var UserInfo___WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(UserInfo___WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var UserInfo___WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(20);
/* harmony import */ var UserInfo___WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(UserInfo___WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var UserInfo___WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(3);
/* harmony import */ var UserInfo___WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(UserInfo___WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_1_jpg__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_1_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_1_jpg__);









var UserInfo__ref = UserInfo___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a('title', {});

var UserInfo__ref2 = UserInfo___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a('g', {}, void 0, UserInfo___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a('path', {
	d: 'M2.502 14.08C3.1 10.64 2 3 8.202 1.62 8.307.697 9.08 0 10 0s1.694.697 1.797 1.62C18 3 16.903 10.64 17.497 14.076c.106 1.102.736 1.855 1.7 2.108.527.142.868.66.793 1.206-.075.546-.542.95-1.09.943H1.1C.55 18.34.084 17.936.01 17.39c-.075-.547.266-1.064.794-1.206.963-.253 1.698-1.137 1.698-2.104zM10 22c-1.417.003-2.602-1.086-2.73-2.51-.004-.062.02-.124.063-.17.043-.045.104-.07.166-.07h5c.063 0 .124.025.167.07.044.046.067.108.063.17-.128 1.424-1.313 2.513-2.73 2.51z'
}, void 0));

var Small = function (_React$Component) {
	UserInfo___WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default.a(Small, _React$Component);

	function Small(props) {
		UserInfo___WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default.a(this, Small);

		return UserInfo___WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default.a(this, (Small.__proto__ || UserInfo___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default.a(Small)).call(this, props));
	}

	UserInfo___WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default.a(Small, [{
		key: 'render',
		value: function render() {
			return UserInfo___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a('div', {
				className: 'Popover PushNotifications AppHeader-notifications'
			}, void 0, UserInfo___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a('button', {
				className: 'Button PushNotifications-icon Button--plain',
				type: 'button'
			}, void 0, UserInfo___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a('svg', {
				viewBox: '0 0 20 22',
				className: 'Icon Icon--news',
				width: '20',
				height: '20',
				'aria-hidden': 'true',
				style: { "height": "20px", "width": "20px" }
			}, void 0, UserInfo__ref, UserInfo__ref2)));
		}
	}]);

	return Small;
}(UserInfo___WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

var UserInfo__ref3 = UserInfo___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a('title', {});

var _ref4 = UserInfo___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a('g', {}, void 0, UserInfo___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a('path', {
	d: 'M9 0C3.394 0 0 4.13 0 8c0 1.654.522 3.763 2.014 5.566.314.292.518.82.454 1.17-.165 1.488-.842 1.905-.842 1.905-.328.332.105.67.588.582 1.112-.2 2.07-.58 3.526-1.122.4-.202.464-.147.78-.078C11.524 17.764 18 14 18 8c0-3.665-3.43-8-9-8z'
}, void 0), UserInfo___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a('path', {
	d: 'M19.14 9.628c.758.988.86 2.01.86 3.15 0 1.195-.62 3.11-1.368 3.938-.21.23-.354.467-.308.722.12 1.073.614 1.5.614 1.5.237.24-.188.563-.537.5-.802-.145-1.494-.42-2.545-.81-.29-.146-.336-.106-.563-.057-2.043.712-4.398.476-6.083-.926 5.964-.524 8.726-3.03 9.93-8.016z'
}, void 0));

var _ref5 = UserInfo___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a('span', {
	className: 'Messages-count'
}, void 0, '2');

var Inform = function (_React$Component2) {
	UserInfo___WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default.a(Inform, _React$Component2);

	function Inform(props) {
		UserInfo___WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default.a(this, Inform);

		return UserInfo___WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default.a(this, (Inform.__proto__ || UserInfo___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default.a(Inform)).call(this, props));
	}

	UserInfo___WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default.a(Inform, [{
		key: 'render',
		value: function render() {
			return UserInfo___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a('div', {}, void 0, UserInfo___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a('div', {
				className: 'Popover Messages AppHeader-messages'
			}, void 0, UserInfo___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a('button', {
				className: 'Button Messages-icon Button--plain',
				type: 'button'
			}, void 0, UserInfo___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a('svg', {
				viewBox: '0 0 20 20',
				className: 'Icon Icon--message',
				width: '20',
				height: '20',
				'aria-hidden': 'true',
				style: { "height": "20px", "width": "20px" }
			}, void 0, UserInfo__ref3, _ref4), _ref5)));
		}
	}]);

	return Inform;
}(UserInfo___WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

var _ref6 = UserInfo___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a('div', {
	className: 'AppHeader-profile'
}, void 0, UserInfo___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a('div', {
	className: 'Popover AppHeader-menu'
}, void 0, UserInfo___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a('button', {
	className: 'Button AppHeader-profileEntry Button--plain',
	type: 'button'
}, void 0, UserInfo___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a('img', {
	className: 'Avatar AppHeader-profileAvatar',
	width: '30',
	height: '30',
	src: __WEBPACK_IMPORTED_MODULE_7__assets_1_jpg___default.a
}))));

var UserData = function (_React$Component3) {
	UserInfo___WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default.a(UserData, _React$Component3);

	function UserData(props) {
		UserInfo___WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default.a(this, UserData);

		return UserInfo___WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default.a(this, (UserData.__proto__ || UserInfo___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default.a(UserData)).call(this, props));
	}

	UserInfo___WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default.a(UserData, [{
		key: 'render',
		value: function render() {
			return _ref6;
		}
	}]);

	return UserData;
}(UserInfo___WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

var _ref7 = UserInfo___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a('div', {
	className: 'AppHeader-userInfo'
}, void 0, UserInfo___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a(Small, {}), UserInfo___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a(Inform, {}), UserInfo___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a(UserData, {}));

var UserInfo = function (_React$Component4) {
	UserInfo___WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default.a(UserInfo, _React$Component4);

	function UserInfo(props) {
		UserInfo___WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default.a(this, UserInfo);

		return UserInfo___WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default.a(this, (UserInfo.__proto__ || UserInfo___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default.a(UserInfo)).call(this, props));
	}

	UserInfo___WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default.a(UserInfo, [{
		key: 'render',
		value: function render() {
			return _ref7;
		}
	}]);

	return UserInfo;
}(UserInfo___WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

/* harmony default export */ var UserInfo_defaultExport = (UserInfo);
// CONCATENATED MODULE: ./src/containers/AppHeader/index.js
/* harmony import */ var AppHeader___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__ = __webpack_require__(9);
/* harmony import */ var AppHeader___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default = __webpack_require__.n(AppHeader___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__);
/* harmony import */ var AppHeader___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(16);
/* harmony import */ var AppHeader___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(AppHeader___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var AppHeader___WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var AppHeader___WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(AppHeader___WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var AppHeader___WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(18);
/* harmony import */ var AppHeader___WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(AppHeader___WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var AppHeader___WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(19);
/* harmony import */ var AppHeader___WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(AppHeader___WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var AppHeader___WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(20);
/* harmony import */ var AppHeader___WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(AppHeader___WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var AppHeader___WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(3);
/* harmony import */ var AppHeader___WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(AppHeader___WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var AppHeader___WEBPACK_IMPORTED_MODULE_7_react_router_dom__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux__ = __webpack_require__(51);


















var AppHeader__ref = AppHeader___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a('header', {
  className: 'Sticky AppHeader is-fixed'
}, void 0, AppHeader___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a('div', {
  className: 'AppHeader-inner'
}, void 0, AppHeader___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a(Brand_defaultExport, {}), AppHeader___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a(Links_defaultExport, {}), AppHeader___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a(SearchBar_defaultExport, {}), AppHeader___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a(UserInfo_defaultExport, {})));

var AppHeader = function (_Component) {
  AppHeader___WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default.a(AppHeader, _Component);

  function AppHeader() {
    AppHeader___WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default.a(this, AppHeader);

    return AppHeader___WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default.a(this, (AppHeader.__proto__ || AppHeader___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default.a(AppHeader)).apply(this, arguments));
  }

  AppHeader___WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default.a(AppHeader, [{
    key: 'render',
    value: function render() {
      return AppHeader__ref;
    }
  }]);

  return AppHeader;
}(AppHeader___WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

/* harmony default export */ var AppHeader_defaultExport = (AppHeader___WEBPACK_IMPORTED_MODULE_7_react_router_dom__["e" /* withRouter */](__WEBPACK_IMPORTED_MODULE_8_react_redux__["b" /* connect */]()(AppHeader)));
// CONCATENATED MODULE: ./src/components/Recommend/index.js
/* harmony import */ var Recommend___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__ = __webpack_require__(9);
/* harmony import */ var Recommend___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default = __webpack_require__.n(Recommend___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__);
/* harmony import */ var Recommend___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(16);
/* harmony import */ var Recommend___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(Recommend___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var Recommend___WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var Recommend___WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(Recommend___WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var Recommend___WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(18);
/* harmony import */ var Recommend___WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(Recommend___WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var Recommend___WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(19);
/* harmony import */ var Recommend___WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(Recommend___WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var Recommend___WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(20);
/* harmony import */ var Recommend___WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(Recommend___WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var Recommend___WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(3);
/* harmony import */ var Recommend___WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(Recommend___WEBPACK_IMPORTED_MODULE_6_react__);








var RecommendChild = function (_React$Component) {
	Recommend___WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default.a(RecommendChild, _React$Component);

	function RecommendChild(props) {
		Recommend___WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default.a(this, RecommendChild);

		return Recommend___WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default.a(this, (RecommendChild.__proto__ || Recommend___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default.a(RecommendChild)).call(this, props));
	}

	Recommend___WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default.a(RecommendChild, [{
		key: 'render',
		value: function render() {
			return Recommend___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a('span', {
				className: 'Topstoryspan',
				rel: this.props.id
			}, void 0, this.props.name);
		}
	}]);

	return RecommendChild;
}(Recommend___WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

var Recommend = function (_React$Component2) {
	Recommend___WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default.a(Recommend, _React$Component2);

	function Recommend(props) {
		Recommend___WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default.a(this, Recommend);

		return Recommend___WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default.a(this, (Recommend.__proto__ || Recommend___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default.a(Recommend)).call(this, props));
	}

	Recommend___WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default.a(Recommend, [{
		key: 'render',
		value: function render() {
			var recArr = [{ name: '电子竞技', id: '001' }, { name: '英雄联盟', id: '002' }, { name: '布姆电竞', id: '003' }];
			var recRender = recArr.map(function (item, index) {
				return Recommend___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a(RecommendChild, {
					name: item.name,
					id: item.id
				}, index);
			});
			return Recommend___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a('div', {}, void 0, recRender);
		}
	}]);

	return Recommend;
}(Recommend___WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

/* harmony default export */ var Recommend_defaultExport = (Recommend);
// CONCATENATED MODULE: ./src/components/TopstoryItem/index.js
/* harmony import */ var TopstoryItem___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__ = __webpack_require__(9);
/* harmony import */ var TopstoryItem___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default = __webpack_require__.n(TopstoryItem___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__);
/* harmony import */ var TopstoryItem___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(16);
/* harmony import */ var TopstoryItem___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(TopstoryItem___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var TopstoryItem___WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var TopstoryItem___WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(TopstoryItem___WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var TopstoryItem___WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(18);
/* harmony import */ var TopstoryItem___WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(TopstoryItem___WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var TopstoryItem___WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(19);
/* harmony import */ var TopstoryItem___WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(TopstoryItem___WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var TopstoryItem___WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(20);
/* harmony import */ var TopstoryItem___WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(TopstoryItem___WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var TopstoryItem___WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(3);
/* harmony import */ var TopstoryItem___WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(TopstoryItem___WEBPACK_IMPORTED_MODULE_6_react__);








var TopstoryItem__ref = TopstoryItem___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a("title", {});

var TopstoryItem__ref2 = TopstoryItem___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a("g", {}, void 0, TopstoryItem___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a("path", {
	d: "M0 15.243c0-.326.088-.533.236-.896l7.98-13.204C8.57.57 9.086 0 10 0s1.43.57 1.784 1.143l7.98 13.204c.15.363.236.57.236.896 0 1.386-.875 1.9-1.955 1.9H1.955c-1.08 0-1.955-.517-1.955-1.9z"
}));

var TopstoryItem__ref3 = TopstoryItem___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a("title", {});

var TopstoryItem__ref4 = TopstoryItem___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a("g", {}, void 0, TopstoryItem___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a("path", {
	d: "M0 15.243c0-.326.088-.533.236-.896l7.98-13.204C8.57.57 9.086 0 10 0s1.43.57 1.784 1.143l7.98 13.204c.15.363.236.57.236.896 0 1.386-.875 1.9-1.955 1.9H1.955c-1.08 0-1.955-.517-1.955-1.9z"
}));

var TopstoryItem__ref5 = TopstoryItem___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a("title", {});

var TopstoryItem__ref6 = TopstoryItem___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a("g", {}, void 0, TopstoryItem___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a("path", {
	d: "M7.24 16.313c-.272-.047-.553.026-.77.2-1.106.813-2.406 1.324-3.77 1.482-.16.017-.313-.06-.394-.197-.082-.136-.077-.308.012-.44.528-.656.906-1.42 1.11-2.237.04-.222-.046-.45-.226-.588C1.212 13.052.027 10.73 0 8.25 0 3.7 4.03 0 9 0s9 3.7 9 8.25-4.373 9.108-10.76 8.063z"
}));

var TopstoryItem__ref7 = TopstoryItem___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a("title", {});

var _ref8 = TopstoryItem___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a("g", {}, void 0, TopstoryItem___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a("path", {
	d: "M.93 3.89C-.135 4.13-.343 5.56.614 6.098L5.89 9.005l8.168-4.776c.25-.128.477.197.273.388L7.05 10.66l.926 5.953c.18 1.084 1.593 1.376 2.182.456l9.644-15.243c.584-.892-.212-2.03-1.234-1.796L.93 3.89z"
}), "\\");

var _ref9 = TopstoryItem___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a("title", {});

var _ref10 = TopstoryItem___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a("g", {}, void 0, TopstoryItem___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a("path", {
	d: "M3.515 17.64l.918-5.355-3.89-3.792c-.926-.902-.64-1.784.64-1.97L6.56 5.74 8.964.87c.572-1.16 1.5-1.16 2.072 0l2.404 4.87 5.377.783c1.28.186 1.566 1.068.64 1.97l-3.89 3.793.918 5.354c.22 1.274-.532 1.82-1.676 1.218L10 16.33l-4.808 2.528c-1.145.602-1.896.056-1.677-1.218z"
}, void 0));

var _ref11 = TopstoryItem___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a("title", {});

var _ref12 = TopstoryItem___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a("g", {}, void 0, TopstoryItem___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a("path", {
	d: "M0 5.437C0 2.505 2.294.094 5.207 0 7.243 0 9.092 1.19 10 3c.823-1.758 2.65-3 4.65-3C17.546 0 20 2.507 20 5.432 20 13.24 11.842 18 10 18 8.158 18 0 13.24 0 5.437z",
	"fill-rule": "evenodd"
}, void 0));

var _ref13 = TopstoryItem___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a("title", {});

var _ref14 = TopstoryItem___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a("g", {}, void 0, TopstoryItem___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a("g", {}, void 0, TopstoryItem___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a("circle", {
	cx: "2",
	cy: "2",
	r: "2"
}), TopstoryItem___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a("circle", {
	cx: "9",
	cy: "2",
	r: "2"
}, void 0), TopstoryItem___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a("circle", {
	cx: "16",
	cy: "2",
	r: "2"
}, void 0)));

var TopstoryItemChildActions = function (_React$Component) {
	TopstoryItem___WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default.a(TopstoryItemChildActions, _React$Component);

	function TopstoryItemChildActions(props) {
		TopstoryItem___WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default.a(this, TopstoryItemChildActions);

		return TopstoryItem___WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default.a(this, (TopstoryItemChildActions.__proto__ || TopstoryItem___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default.a(TopstoryItemChildActions)).call(this, props));
	}

	TopstoryItem___WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default.a(TopstoryItemChildActions, [{
		key: "render",
		value: function render() {
			return TopstoryItem___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a("div", {
				className: "ContentItem-actions"
			}, void 0, TopstoryItem___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a("span", {}, void 0, TopstoryItem___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a("button", {
				className: "Button VoteButton VoteButton--up",
				"aria-label": "\u8D5E\u540C",
				type: "button"
			}, void 0, TopstoryItem___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a("svg", {
				viewBox: "0 0 20 18",
				className: "Icon VoteButton-upIcon Icon--triangle",
				width: "9",
				height: "16",
				"aria-hidden": "true",
				style: { "height": "16px", "width": "9px" }
			}, void 0, TopstoryItem__ref, TopstoryItem__ref2), "3.7K"), TopstoryItem___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a("button", {
				className: "Button VoteButton VoteButton--down",
				"aria-label": "\u53CD\u5BF9",
				type: "button"
			}, void 0, TopstoryItem___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a("svg", {
				viewBox: "0 0 20 18",
				className: "Icon VoteButton-downIcon Icon--triangle",
				width: "9",
				height: "16",
				"aria-hidden": "true",
				style: { "height": "16px", "width": "13px" }
			}, void 0, TopstoryItem__ref3, TopstoryItem__ref4))), TopstoryItem___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a("button", {
				className: "Button ContentItem-action Button--plain",
				type: "button"
			}, void 0, TopstoryItem___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a("svg", {
				viewBox: "0 0 18 18",
				xmlns: "http://www.w3.org/2000/svg",
				className: "Icon Icon--comment Icon--left",
				width: "12",
				height: "16",
				"aria-hidden": "true",
				style: { "height": "16px", "width": "12px" }
			}, void 0, TopstoryItem__ref5, TopstoryItem__ref6), this.props.number, " \u6761\u8BC4\u8BBA"), TopstoryItem___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a("div", {
				className: "Popover ShareMenu ContentItem-action"
			}, void 0, TopstoryItem___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a("div", {}, void 0, TopstoryItem___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a("button", {
				className: "Button Button--plain",
				type: "button"
			}, void 0, TopstoryItem___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a("svg", {
				viewBox: "0 0 20 18",
				xmlns: "http://www.w3.org/2000/svg",
				className: "Icon Icon--share Icon--left",
				width: "13",
				height: "16",
				"aria-hidden": "true",
				style: { "height": "16px", "width": "13px" }
			}, void 0, TopstoryItem__ref7, _ref8), "\u5206\u4EAB"))), TopstoryItem___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a("button", {
				className: "Button ContentItem-action Button--plain",
				type: "button"
			}, void 0, TopstoryItem___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a("svg", {
				viewBox: "0 0 20 20",
				className: "Icon Icon--star Icon--left",
				width: "13",
				height: "16",
				"aria-hidden": "true",
				style: { "height": "16px", "width": "13px" }
			}, void 0, _ref9, _ref10), "\u6536\u85CF"), TopstoryItem___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a("button", {
				className: "Button ContentItem-action Button--plain",
				type: "button"
			}, void 0, TopstoryItem___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a("svg", {
				width: "14",
				height: "16",
				viewBox: "0 0 20 18",
				xmlns: "http://www.w3.org/2000/svg",
				className: "Icon Icon--thank Icon--left",
				"aria-hidden": "true",
				style: { "height": "16px", "width": "13px" }
			}, void 0, _ref11, _ref12), "\u611F\u8C22"), TopstoryItem___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a("div", {
				className: "Popover ContentItem-action"
			}, void 0, TopstoryItem___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a("button", {
				className: "Button Button--plain",
				type: "button"
			}, void 0, TopstoryItem___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a("svg", {
				viewBox: "0 0 18 4",
				className: "Icon Icon--dots",
				width: "14",
				height: "16",
				style: { "height": "16px", "width": "13px" }
			}, void 0, _ref13, _ref14))));
		}
	}]);

	return TopstoryItemChildActions;
}(TopstoryItem___WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

var _ref15 = TopstoryItem___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a("title", {});

var _ref16 = TopstoryItem___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a("g", {}, void 0, TopstoryItem___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a("path", {
	d: "M8.486 7l5.208-5.207c.408-.408.405-1.072-.006-1.483-.413-.413-1.074-.413-1.482-.005L7 5.515 1.793.304C1.385-.103.72-.1.31.31-.103.724-.103 1.385.305 1.793L5.515 7l-5.21 5.207c-.407.408-.404 1.072.007 1.483.413.413 1.074.413 1.482.005L7 8.485l5.207 5.21c.408.407 1.072.404 1.483-.007.413-.413.413-1.074.005-1.482L8.485 7z"
}));

var TopstoryItemChildButton = function (_React$Component2) {
	TopstoryItem___WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default.a(TopstoryItemChildButton, _React$Component2);

	function TopstoryItemChildButton(props) {
		TopstoryItem___WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default.a(this, TopstoryItemChildButton);

		return TopstoryItem___WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default.a(this, (TopstoryItemChildButton.__proto__ || TopstoryItem___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default.a(TopstoryItemChildButton)).call(this, props));
	}

	TopstoryItem___WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default.a(TopstoryItemChildButton, [{
		key: "render",
		value: function render() {
			return TopstoryItem___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a("button", {
				className: "Button TopstoryItem-rightButton Button--plain",
				"data-tooltip": "\u4E0D\u611F\u5174\u8DA3",
				"data-tooltip-position": "bottom",
				type: "button"
			}, void 0, TopstoryItem___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a("svg", {
				viewBox: "0 0 14 14",
				className: "Icon Icon--remove",
				width: "10",
				height: "10",
				style: { "height": "10px", "width": "10px" }
			}, void 0, _ref15, _ref16));
		}
	}]);

	return TopstoryItemChildButton;
}(TopstoryItem___WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

var _ref17 = TopstoryItem___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a(TopstoryItemChildButton, {});

var TopstoryItemChild = function (_React$Component3) {
	TopstoryItem___WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default.a(TopstoryItemChild, _React$Component3);

	function TopstoryItemChild(props) {
		TopstoryItem___WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default.a(this, TopstoryItemChild);

		return TopstoryItem___WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default.a(this, (TopstoryItemChild.__proto__ || TopstoryItem___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default.a(TopstoryItemChild)).call(this, props));
	}

	TopstoryItem___WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default.a(TopstoryItemChild, [{
		key: "render",
		value: function render() {
			return TopstoryItem___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a("div", {
				className: "Card TopstoryItem"
			}, void 0, _ref17, TopstoryItem___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a("h1", {}, void 0, this.props.name), TopstoryItem___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a("p", {}, void 0, this.props.content), TopstoryItem___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a(TopstoryItemChildActions, {
				number: this.props.number
			}));
		}
	}]);

	return TopstoryItemChild;
}(TopstoryItem___WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

var TopstoryItem = function (_React$Component4) {
	TopstoryItem___WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default.a(TopstoryItem, _React$Component4);

	function TopstoryItem(props) {
		TopstoryItem___WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default.a(this, TopstoryItem);

		return TopstoryItem___WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default.a(this, (TopstoryItem.__proto__ || TopstoryItem___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default.a(TopstoryItem)).call(this, props));
	}

	TopstoryItem___WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default.a(TopstoryItem, [{
		key: "render",
		value: function render() {
			var recArr = [{ name: '这条新闻里标价30万的镯子实际价格大约是多少？', number: '233', content: '这事我不做发言权，我又来回答无关紧要的问题了，因为我只想问问一些同行，你们做生意不？！还有一些整天看热闹仇富的，你们是不是一点自身利益都没有啊？ 估价多少？8W，10W，16W，不是你们说了算！什么估价…' }, {
				name: '为什么感觉Steam突然火了？',
				number: '1233',
				content: '我提一句，其实你们要感谢一下完美世界，steam的专线是完美出资拉的。如果没有完美的线，steam的下载速度就跟坑爹的PSN一样了，PS4还有实体版来降低网速带来的不便，Steam就没那么幸运了。加上完美在北京的关系和他们的努力公关，使得steam没有变成推特或脸叔...'
			}];
			var recRender = recArr.map(function (item, index) {
				return TopstoryItem___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a(TopstoryItemChild, {
					name: item.name,
					content: item.content,
					number: item.number
				}, index);
			});
			return TopstoryItem___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a("div", {}, void 0, recRender);
		}
	}]);

	return TopstoryItem;
}(TopstoryItem___WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

/* harmony default export */ var TopstoryItem_defaultExport = (TopstoryItem);
// CONCATENATED MODULE: ./src/components/TopstorySideBar/index.js
/* harmony import */ var TopstorySideBar___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__ = __webpack_require__(9);
/* harmony import */ var TopstorySideBar___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default = __webpack_require__.n(TopstorySideBar___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__);
/* harmony import */ var TopstorySideBar___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(16);
/* harmony import */ var TopstorySideBar___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(TopstorySideBar___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var TopstorySideBar___WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var TopstorySideBar___WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(TopstorySideBar___WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var TopstorySideBar___WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(18);
/* harmony import */ var TopstorySideBar___WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(TopstorySideBar___WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var TopstorySideBar___WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(19);
/* harmony import */ var TopstorySideBar___WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(TopstorySideBar___WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var TopstorySideBar___WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(20);
/* harmony import */ var TopstorySideBar___WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(TopstorySideBar___WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var TopstorySideBar___WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(3);
/* harmony import */ var TopstorySideBar___WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(TopstorySideBar___WEBPACK_IMPORTED_MODULE_6_react__);








var TopstorySideBar__ref = TopstorySideBar___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a("p", {
	className: "StickyCard-p"
}, void 0, "\u5173\u6CE8\u8005");

var TopstorySideBar__ref2 = TopstorySideBar___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a("div", {
	className: "Popover StickyCard-i"
});

var TopstorySideBar__ref3 = TopstorySideBar___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a("p", {
	className: "StickyCard-p"
}, void 0, "\u88AB\u6D4F\u89C8");

var UserInfoCard = function (_React$Component) {
	TopstorySideBar___WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default.a(UserInfoCard, _React$Component);

	function UserInfoCard(props) {
		TopstorySideBar___WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default.a(this, UserInfoCard);

		var _this = TopstorySideBar___WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default.a(this, (UserInfoCard.__proto__ || TopstorySideBar___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default.a(UserInfoCard)).call(this, props));

		_this.state = {
			barnumebr: 30,
			barall: 3124
		};
		return _this;
	}

	TopstorySideBar___WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default.a(UserInfoCard, [{
		key: "render",
		value: function render() {
			return TopstorySideBar___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a("div", {
				className: "StickyCard"
			}, void 0, TopstorySideBar___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a("div", {
				className: "Popover"
			}, void 0, TopstorySideBar__ref, TopstorySideBar___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a("p", {}, void 0, this.state.barnumebr)), TopstorySideBar__ref2, TopstorySideBar___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a("div", {
				className: "Popover"
			}, void 0, TopstorySideBar__ref3, TopstorySideBar___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a("p", {}, void 0, this.state.barall)));
		}
	}]);

	return UserInfoCard;
}(TopstorySideBar___WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

var TopstorySideBar__ref4 = TopstorySideBar___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a("div", {
	className: "StickyHandle"
}, void 0, TopstorySideBar___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a("button", {
	className: "Button QuestionAskButton SearchBar-askButton Button--primary Button--blue",
	type: "button"
}, void 0, "\u5173\u6CE8\u63D0\u95EE"), TopstorySideBar___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a("button", {
	className: "Button QuestionAskButton SearchBar-askButton Button--primary Button--albedo",
	type: "button"
}, void 0, "\u5199\u56DE\u7B54"));

var UserInfoData = function (_React$Component2) {
	TopstorySideBar___WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default.a(UserInfoData, _React$Component2);

	function UserInfoData(props) {
		TopstorySideBar___WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default.a(this, UserInfoData);

		return TopstorySideBar___WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default.a(this, (UserInfoData.__proto__ || TopstorySideBar___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default.a(UserInfoData)).call(this, props));
	}

	TopstorySideBar___WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default.a(UserInfoData, [{
		key: "render",
		value: function render() {
			return TopstorySideBar__ref4;
		}
	}]);

	return UserInfoData;
}(TopstorySideBar___WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

var TopstorySideBar__ref5 = TopstorySideBar___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a("div", {
	className: "Sticky Card"
}, void 0, TopstorySideBar___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a(UserInfoCard, {}), TopstorySideBar___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a(UserInfoData, {}));

var TopstorySideBar = function (_React$Component3) {
	TopstorySideBar___WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default.a(TopstorySideBar, _React$Component3);

	function TopstorySideBar(props) {
		TopstorySideBar___WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default.a(this, TopstorySideBar);

		return TopstorySideBar___WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default.a(this, (TopstorySideBar.__proto__ || TopstorySideBar___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default.a(TopstorySideBar)).call(this, props));
	}

	TopstorySideBar___WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default.a(TopstorySideBar, [{
		key: "render",
		value: function render() {
			return TopstorySideBar__ref5;
		}
	}]);

	return TopstorySideBar;
}(TopstorySideBar___WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

/* harmony default export */ var TopstorySideBar_defaultExport = (TopstorySideBar);
// CONCATENATED MODULE: ./src/containers/AppContainers/index.js
/* harmony import */ var AppContainers___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__ = __webpack_require__(9);
/* harmony import */ var AppContainers___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default = __webpack_require__.n(AppContainers___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__);
/* harmony import */ var AppContainers___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(16);
/* harmony import */ var AppContainers___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(AppContainers___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var AppContainers___WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var AppContainers___WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(AppContainers___WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var AppContainers___WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(18);
/* harmony import */ var AppContainers___WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(AppContainers___WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var AppContainers___WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(19);
/* harmony import */ var AppContainers___WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(AppContainers___WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var AppContainers___WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(20);
/* harmony import */ var AppContainers___WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(AppContainers___WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var AppContainers___WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(3);
/* harmony import */ var AppContainers___WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(AppContainers___WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var AppContainers___WEBPACK_IMPORTED_MODULE_7_react_router_dom__ = __webpack_require__(42);
/* harmony import */ var AppContainers___WEBPACK_IMPORTED_MODULE_8_react_redux__ = __webpack_require__(51);
















var AppContainers__ref = AppContainers___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a('section', {
  className: 'Sticky AppRecommend Topstory-container'
}, void 0, AppContainers___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a('section', {
  className: 'Topstory-mainColumn'
}, void 0, AppContainers___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a('div', {
  className: 'TopstoryHeader Card'
}, void 0, AppContainers___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a(Recommend_defaultExport, {})), AppContainers___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a('div', {
  className: 'TopstoryMain'
}, void 0, AppContainers___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a(TopstoryItem_defaultExport, {}))), AppContainers___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a('section', {
  className: 'TopstorySideBar'
}, void 0, AppContainers___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a(TopstorySideBar_defaultExport, {})));

var AppContainers = function (_Component) {
  AppContainers___WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default.a(AppContainers, _Component);

  function AppContainers() {
    AppContainers___WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default.a(this, AppContainers);

    return AppContainers___WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default.a(this, (AppContainers.__proto__ || AppContainers___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default.a(AppContainers)).apply(this, arguments));
  }

  AppContainers___WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default.a(AppContainers, [{
    key: 'render',
    value: function render() {
      return AppContainers__ref;
    }
  }]);

  return AppContainers;
}(AppContainers___WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

/* harmony default export */ var AppContainers_defaultExport = (AppContainers___WEBPACK_IMPORTED_MODULE_7_react_router_dom__["e" /* withRouter */](AppContainers___WEBPACK_IMPORTED_MODULE_8_react_redux__["b" /* connect */]()(AppContainers)));
// CONCATENATED MODULE: ./src/containers/HomeContainer/index.js
/* harmony import */ var HomeContainer___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__ = __webpack_require__(9);
/* harmony import */ var HomeContainer___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default = __webpack_require__.n(HomeContainer___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__);
/* harmony import */ var HomeContainer___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(16);
/* harmony import */ var HomeContainer___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(HomeContainer___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var HomeContainer___WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var HomeContainer___WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(HomeContainer___WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var HomeContainer___WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(18);
/* harmony import */ var HomeContainer___WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(HomeContainer___WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var HomeContainer___WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(19);
/* harmony import */ var HomeContainer___WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(HomeContainer___WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var HomeContainer___WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(20);
/* harmony import */ var HomeContainer___WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(HomeContainer___WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var HomeContainer___WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(3);
/* harmony import */ var HomeContainer___WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(HomeContainer___WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var HomeContainer___WEBPACK_IMPORTED_MODULE_7_react_router_dom__ = __webpack_require__(42);
/* harmony import */ var HomeContainer___WEBPACK_IMPORTED_MODULE_8_react_redux__ = __webpack_require__(51);














var HomeContainer__ref = HomeContainer___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a('main', {}, void 0, HomeContainer___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a(AppHeader_defaultExport, {}), HomeContainer___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a(AppContainers_defaultExport, {}));

var HomeContainer = function (_Component) {
  HomeContainer___WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default.a(HomeContainer, _Component);

  function HomeContainer() {
    HomeContainer___WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default.a(this, HomeContainer);

    return HomeContainer___WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default.a(this, (HomeContainer.__proto__ || HomeContainer___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default.a(HomeContainer)).apply(this, arguments));
  }

  HomeContainer___WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default.a(HomeContainer, [{
    key: 'render',
    value: function render() {
      return HomeContainer__ref;
    }
  }]);

  return HomeContainer;
}(HomeContainer___WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

/* harmony default export */ var HomeContainer_defaultExport = (HomeContainer___WEBPACK_IMPORTED_MODULE_7_react_router_dom__["e" /* withRouter */](HomeContainer___WEBPACK_IMPORTED_MODULE_8_react_redux__["b" /* connect */]()(HomeContainer)));
// CONCATENATED MODULE: ./src/routers/index.js
/* harmony import */ var routers___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__ = __webpack_require__(9);
/* harmony import */ var routers___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default = __webpack_require__.n(routers___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__);
/* harmony import */ var routers___WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(3);
/* harmony import */ var routers___WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(routers___WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(42);







var routes = routers___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* HashRouter */], {
  basename: 'app'
}, void 0, routers___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a(AppContainer_defaultExport, {}, void 0, routers___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Switch */], {}, void 0, routers___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["c" /* Route */], {
  path: '/home',
  component: HomeContainer_defaultExport
})), routers___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Redirect */], {
  from: '/',
  to: '/home'
})));

/* harmony default export */ var routers_defaultExport = (routes);
// CONCATENATED MODULE: ./src/main.js
/* harmony import */ var main___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__ = __webpack_require__(9);
/* harmony import */ var main___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default = __webpack_require__.n(main___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__);
/* harmony import */ var main___WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(3);
/* harmony import */ var main___WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(main___WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_saga__ = __webpack_require__(148);











var sagaMiddleware = __WEBPACK_IMPORTED_MODULE_5_redux_saga__["a" /* default */]();
var store = __WEBPACK_IMPORTED_MODULE_4_redux__["d" /* createStore */](reducers_defaultExport, __WEBPACK_IMPORTED_MODULE_4_redux__["a" /* applyMiddleware */](sagaMiddleware));
sagaMiddleware.run(rootSaga);

__WEBPACK_IMPORTED_MODULE_2_react_dom___default.a.render(main___WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default.a(__WEBPACK_IMPORTED_MODULE_3_react_redux__["a" /* Provider */], {
  store: store
}, void 0, routers_defaultExport), document.getElementById('app'));

/***/ }),

/***/ 343:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 344:
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAEBAQEBAQEBAQEBAQEBAQIBAQEBAQIBAQECAgICAgICAgIDAwQDAwMDAwICAwQDAwQEBAQEAgMFBQQEBQQEBAT/2wBDAQEBAQEBAQIBAQIEAwIDBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAT/wAARCAAiACIDASIAAhEBAxEB/8QAHwAAAQUBAQEBAQEAAAAAAAAAAAECAwQFBgcICQoL/8QAtRAAAgEDAwIEAwUFBAQAAAF9AQIDAAQRBRIhMUEGE1FhByJxFDKBkaEII0KxwRVS0fAkM2JyggkKFhcYGRolJicoKSo0NTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uHi4+Tl5ufo6erx8vP09fb3+Pn6/8QAHwEAAwEBAQEBAQEBAQAAAAAAAAECAwQFBgcICQoL/8QAtREAAgECBAQDBAcFBAQAAQJ3AAECAxEEBSExBhJBUQdhcRMiMoEIFEKRobHBCSMzUvAVYnLRChYkNOEl8RcYGRomJygpKjU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6goOEhYaHiImKkpOUlZaXmJmaoqOkpaanqKmqsrO0tba3uLm6wsPExcbHyMnK0tPU1dbX2Nna4uPk5ebn6Onq8vP09fb3+Pn6/9oADAMBAAIRAxEAPwD+ziinQ297e3MNjp1uLq9nDtDb+YImm8uN5nVSeNxWN9oOAWwMjOaqRXUUxVIt8kznaLeONpbrcDgr5QBfIIII25BBBGRigCz/AJ/z+Y/OiuksfAviG/0ifVodNu4NQXVlgg06+IsJbmzEKlpVSQqFIleTG/aWUNx90HyXxJ4zTwvrN/oWoaVdy32llRfra3lrIkO6NJMA+Z8xAkTIHc4zQB21FV7a4+121vdQqGiuYEuIizbGKuoZSQeRwRxRQB1vgVd/jjRAM/ura8uP++bcx/8Atevetf0FtX0XVtL03Urzw1eapGVGt6IqQanaOWDGRGIxuOCCTz8x5zzXh3w1Qy+PE4BW18N3k7HGcGSexjQfjiT8jX0lQBSlmg0zT5Li9u9ttYWZlu726YKQkSZeWQgAdFLEgevFfCXi3wtpPjDx9rviW1Nw2h6ldRXKRXdqbW4uZEjWOQkE5WJygYBgJGBwQg+99s+LYxL4V8SxHP7zQLxRjqD9nkxXyzbEGFCOhyemOpNADFs4FVVAbCgKMOVHHsOB+FFWqKAO8+E4B8VeIGIBZfD9mFbHIBvLzIB98D8hX0JRRQBg+KePDXiHH/QDu/8A0nlr5Us/+PaH/coooAs0UUUAf//Z"

/***/ })

},[166]);


// WEBPACK FOOTER //
// static/js/app.8c4e1345.js